import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/souls.pdf'; /*Change pdf*/
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {       /*Change left hand panel content*/
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
        Shelfmark LH 4, 3, 5e Bl. 28<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: c. 1694-1695<br /><br />
        Translated from the Latin<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (139k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Souls</title> {/*Change title*/}
            <meta name="description" content="An English translation of SOULS by Gottfried Wilhelm Leibniz, date unknown" /> {/*Change meta description*/}
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: SOULS</h2> {/*Change title*/}
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br /> {/*Change page content*/}
                 <small>This short set of remarks was written on one side of a strip of paper torn from a larger sheet. The watermark is commonly attested to 1694 and the first quarter of 1695.</small><br /><br /><br />

                 [<b>LH 4, 3, 5e Bl. 28</b>]<br /><br />
                
                 <var>Downward</var>, that is, toward the sun, according to the true system of the world.<br />
<hr width="10%"></hr>
I think it is false that souls sleep; however, if they were to sleep for many thousands of years, they would do so without any inconvenience to themselves. For to the one who is sleeping, time does not pass.<br />
<hr width="10%"></hr>
The Druids believed that souls go to another world: “the self-same spirit rules our limbs in some other world” - Lucan.<a name="1" href="#note1"><sup>1</sup></a>
                <br /><br /><br />
                <hr className='rightcol-hr' />
                        <br /><br />
                        NOTES:<br /><br />
                        <a name="note1" href="#1">1.</a> Leibniz here quotes Lucan, <var>Pharsalia</var>, I, 456-457. English translation from Lucan, <var>Pharsalia</var>, ed. and trans. Jane Wilson Joyce (Ithaca: Cornell University Press, 1993), 19.<br /><br /><br />
                  &#169; Lloyd Strickland 2024
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
